define(['jquery',
        'core/urls', 
        'components/modal', 
        'components/preview-flow',
        'components/dropdown',
        'core/iterate',
        'core/utilities'
    ],
    function ($, urls, modal, preview, DD, iterate, utilities) {
        var nodes = {
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    // document.querySelector(".nps-s1-setup-campaign"),
                    // document.querySelector(".navigation-main"),
                    // document.querySelector(".navigation-top")
                ]
            },
            previewModal: {
                wrapper: document.querySelector(".preview_js"),
                closeButton: document.querySelector(".preview-close_js"),
                continueButton: document.querySelector(".preview-continue_js"),
                steps: document.querySelector(".preview-steps_js"),
                content: document.querySelector(".preview-content_js"),
                navigation: document.querySelector(".preview-nav_js"),
            },
            modalContent: document.querySelector('.modal-template-survey-preview_js'),
            $form: $('#configure-feedback-form'),
            previewWindow: document.querySelector('.preview_window_js')
        };

        function checkForQuestionMark(message) {
            message = message.trim();
            var lastCharacter = message.slice(-1);
            return {
                questionMark: lastCharacter === "?" ? '?' : '',
                text: lastCharacter === "?" ? message.slice(0, -1) : message
            }
        }

        function formatFeedbackPreview () {
                var previewContent = nodes.previewModal.content;
                let feedbackQuestion = previewContent.querySelector("#header.feedback-form__message");
                let scoreSelector = previewContent.querySelector(".custom-select");

                let msgOptions = checkForQuestionMark(feedbackQuestion.innerText)

                let modifiedQuestion = `${utilities.sanitizeData(msgOptions.text)} ${scoreSelector.outerHTML} ${msgOptions.questionMark}`;
                feedbackQuestion.innerHTML = modifiedQuestion;

                // hide original score selector
                let template = previewContent.querySelectorAll("#score")[1];
                template.style.display = "none";

                // format drop down
                DD(feedbackQuestion.querySelector(".custom-select"));

                document.querySelector(".feedback-form .feedback-select").classList.remove("hide");
                document.querySelectorAll(".feedback-form .feedback-select .mock-options div")[10].click();            
        }


        // steps to pass into preview component
        let previewConfig = {
            nextPage: urls['nps:survey'](),
            steps: [
                    {
                        title: "Comment",
                        url: urls['nps:preview-feedback'](),
                        method: "GET",
                        callback: formatFeedbackPreview
                    },
                    {
                        title: "Thank You",
                        url: urls['nps:preview-thank-you'](),
                        method: "GET"
                    },
                ]
            };

        let previewModal = preview.create(nodes.previewModal, previewConfig)
        

        return {
            init: function () {

                let googleCheckbox =  document.querySelector("#id_is_google_reviews_available");
                let googleTextField = document.querySelector("#id_google_business_link");

                googleCheckbox.checked ? googleTextField.removeAttribute("disabled") : googleTextField.setAttribute("disabled", '');

                googleCheckbox.addEventListener("change", () => {
                    googleCheckbox.checked ? googleTextField.removeAttribute("disabled") : googleTextField.setAttribute("disabled", '');
                })

                var createdModal = modal.create(nodes.modal);

                [...document.querySelectorAll("img.reset-feedback_js")].forEach(node => {
                    let ta = node.parentNode.querySelector("textarea");
                    node.addEventListener("click", (e) => {
                        ta.value = ta.dataset.default;
                        e.target.classList.add("roll");
                        setTimeout(()=>{
                            e.target.classList.remove("roll")
                        },300)

                    })
                });

                let hrefs = document.querySelectorAll("a[href]");
                let modalTemplate = document.querySelector(".modal-template-leave_js")

                let hrefsToIgnore = [
                    urls['nps:campaign'](), 
                    urls['nps:configure-email'](), 
                    urls['nps:configure-feedback'](), 
                    urls['nps:survey']()
                ] 

                iterate(hrefs, function (node) {
                    node.addEventListener("click", event => {
                        utilities.confirmPageExit(event, createdModal, modalTemplate, null, hrefsToIgnore);
                    });
                });

                let submit = document.querySelector("input[type=\"submit\"]");

                submit.addEventListener("click", (e) => {
                    e.preventDefault();

                    let error = false;
                    nodes.$form.find("textarea").each((k, i) => {
                        if (i.value.trim().length === 0) {
                            i.classList.add("danger");
                            i.nextElementSibling.classList.remove("disabled");
                            error = true;
                        } else {
                            i.classList.remove("danger");
                            i.nextElementSibling.classList.add("disabled");
                        }
                    });

                    if (!error) {
                        $.post('', nodes.$form.serialize()).done(function (response) {


                            let googleInput = document.querySelector(".google-input input");
                            let errorNode = document.querySelector(".google-input .error-message");
                            
                            googleInput.classList.remove("danger");
                            errorNode.classList.add("disabled");

                            let error = $(response).find(".google-input").attr("data-error");


                            if(error !== "") {
                                let pos1 = error.lastIndexOf("<li>");
                                let parsedError = error.substr(pos1 + 4, error.length)
                                let pos2 = parsedError.indexOf("</li>");
                                parsedError = parsedError.substr(0, pos2);

                                let errorNode = document.querySelector(".google-input .error-message");
                                errorNode.innerText = parsedError
                                errorNode.classList.remove("disabled");

                                googleInput.classList.add("danger");

                                return;
                            }

                            function callUpdate() {
                                $.ajax({
                                    url: urls['nps:update']()
                                })
                            }

                            previewModal.open(callUpdate);

                        });
                    }
                });
            }
        }
    }
);
